<template>
    <div class="my-5">
        <label>{{placeholder}}</label>
        <div>
            <input v-if="type=='text'||type=='email'" class="w-full p-3 border-b-2 md:w-8/12 border-light_gray" :type="type" :placeholder="placeholder" v-model="input" />
            <input v-if="type=='number'" class="w-full p-3 border-b-2 md:w-8/12 border-light_gray" :type="type" :placeholder="placeholder" step="any" v-model="input" />
            <textarea v-if="type=='textarea'" class="w-full p-3 border-b-2 md:w-8/12 border-light_gray" :name="placeholder" v-model="input" rows="5"></textarea>
        </div>
    </div>
</template>

<script>
import { ref } from '@vue/reactivity'
import { watch } from '@vue/runtime-core';

export default {
    props: ['type','placeholder','value'],
    setup(props,{ emit }){
        let input = ref(props.value);

        watch(input, value => {
            emit('update:modelValue', value);
        });

        return{
            input
        }
    }
}
</script>

<style>

</style>